/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 24/11/21
 */
import React, {memo, useState, useRef, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Spin} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import styles from './index.less';
import ContentEditable from 'react-contenteditable';
import classNames from 'classnames';
import {useCrudSections} from '@/modules/templates/hooks/useSections';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const SectionTitleEdit = ({section}) => {
  const text = useRef(section?.title || '');
  const {update, isUpdating} = useCrudSections();

  const [editing, setEditing] = useState( false);

  const handleEdit = useCallback(async () => {
    setEditing(false);
    if (!text?.current || !text?.current?.trim() || section?.title === text?.current) {
      return;
    }
    await update({_id: section?._id, title: text?.current?.trim()});
  }, [section, update]);

  const handleChange = useCallback(evt => {
    text.current = evt.currentTarget.textContent;
    setEditing(true);
  }, []);

  const handleKeyDown = useCallback((evt) => {
    if (evt.key === 'Enter' || evt.code === 'Enter') {
      evt.preventDefault();
      document.getElementById(`editable-${section?._id}`).blur();
    }
  }, [section?._id]);

  return (
    <div className="flex items-center justify-between w-full">
      <Spin indicator={antIcon} spinning={isUpdating} className={styles.spinner}>
        <div className={styles.sectionName}>
          <ContentEditable
            disabled={isUpdating}
            id={`editable-${section?._id}`}
            key={`editable-${section?._id}`}
            onKeyDown={handleKeyDown}
            className={classNames(editing ? styles.contentEditableEditing : styles.contentEditable, editing ? 'name-is-editing w-full' : '', 'h-8 w-full')}
            html={text?.current || ''}
            onFocus={(e) => {
              e.preventDefault();
              setEditing(true);
            }}
            onBlur={handleEdit}
            onChange={handleChange}
            isEditing={editing ? 'true' : 'false'}
          />
        </div>
      </Spin>
    </div>
  );
};

SectionTitleEdit.propTypes = {
  section: PropTypes.object,
  defaultSelected: PropTypes.bool,
  selected: PropTypes.object,
  setSelected: PropTypes.func,
  setSelectedTask: PropTypes.func,
  hasSelectedTask: PropTypes.bool,
  dragHandleProps: PropTypes.any,
};

export default memo(SectionTitleEdit);
